'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _header = _interopRequireDefault(require("./header"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function defaultHeaderRenderer(_ref) {
  var className = _ref.className,
      scrolledColumns = _ref.scrolledColumns,
      columns = _ref.columns,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection,
      minVisibleColumns = _ref.minVisibleColumns,
      maxVisibleColumns = _ref.maxVisibleColumns,
      rowCount = _ref.rowCount,
      onSort = _ref.onSort,
      onScrollRight = _ref.onScrollRight,
      onScrollLeft = _ref.onScrollLeft,
      loading = _ref.loading,
      height = _ref.height,
      style = _ref.style;
  return _react["default"].createElement(_header["default"], {
    className: className,
    style: style,
    scrolledColumns: scrolledColumns,
    columns: columns,
    sortBy: sortBy,
    sortDirection: sortDirection,
    minVisibleColumns: minVisibleColumns,
    maxVisibleColumns: maxVisibleColumns,
    rowCount: rowCount,
    onSort: onSort,
    onScrollRight: onScrollRight,
    onScrollLeft: onScrollLeft,
    height: height,
    loading: loading
  });
}

var _default = defaultHeaderRenderer;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/table/default_header_renderer.js
// module id = 216
// module chunks = 0